import AdminLayout from './adminLayout';

export default AdminLayout;
